import { gql } from "@apollo/client";

export const SEND_EMAIL = gql`
  mutation SendEmail($data: SendEmailInput!) {
    sendEmail(data: $data)
  }
`;

export const ADD_EMAIL_TEMPLATE = gql`
  mutation AddEmailTemplate($data: EmailTemplateDataInput) {
    addEmailTemplate(data: $data) {
      id
      label
      description
      icon
      subject
      body
      active
      createdDate
    }
  }
`;

export const UPDATE_EMAIL_TEMPLATE = gql`
  mutation UpdateEmailTemplate(
    $where: EmailTemplateWhereInput
    $data: EmailTemplateDataInput
  ) {
    updateEmailTemplate(where: $where, data: $data) {
      id
      label
      description
      icon
      subject
      body
      active
      updatedDate
    }
  }
`;

export const DELETE_EMAIL_TEMPLATE = gql`
  mutation DeleteEmailTemplate($where: EmailTemplateWhereInput) {
    deleteEmailTemplate(where: $where) {
      id
    }
  }
`;
